import _ from 'lodash';
import axios from 'axios';
import { coinDesc, algorithmDesc } from '@/api/const';

const algorithms = ['SHA256', 'DAGGERHASHIMOTO'];

export default {
  async list() {
    const ids = algorithms.map(a => 'NICEHASH-STANDARD-' + a);
    const { data } = await axios.get(
      'https://8xiscecoe2.execute-api.ap-northeast-1.amazonaws.com/production/hashpower/nicehash/latest',
      { params: { ids } }
      );
    return data.map(d => ({
      ...d,
      payoffType: algorithmDesc[_.last(d.id.split('-'))].payoffType,
      type: 'REALTIME',
      issuer: 'nicehash'
    }));
  },
  getFullData(item, coin, blockchainInfo) {
    const blockchain = blockchainInfo[coin];

    const priceUsd = item.price * blockchainInfo.BTC.price;
    const priceBtc = item.price;
    const priceCoin = priceUsd / blockchain.price;

    return {
      ...item,
      coin, priceUsd, priceBtc, priceCoin,
      url: `https://www.nicehash.com/my/marketplace/${coinDesc[coin].algorithm}`,
      payoff: blockchain.miningEarning * blockchain.price,
      payoffCoin: blockchain.miningEarning,
      costBasis: priceCoin / blockchain.miningEarning * blockchain.price,
      discount: 1 - priceCoin / blockchain.miningEarning
    };
  }
}